import { Component, OnInit, ElementRef, Input } from '@angular/core';
import { DialogService } from "../dialog";
import { DialogComponent } from "../dialog/dialog.component";
import { InTransactionsService } from '../../services/inventory/in-transactions.service';
import { DataService } from '../../services/data.service';
export interface ConfirmModelRequisition {
  title: string;
  message: string;
  data: any;
}
@Component({
  selector: 'app-materialrequisition-search',
  templateUrl: './materialrequisition-search.component.html',
  styleUrls: ['./materialrequisition-search.component.css']
})
export class MaterialrequisitionSearchComponent extends DialogComponent<ConfirmModelRequisition, boolean> implements ConfirmModelRequisition, OnInit {
  title: string;
  message: string;
  loading: boolean = false;
  result: any = { item: [], result: false };;
  rtnData: any;
  data: any;
  selectedRow: number = -1;
  sliceStrat: number = 0;
  sliceEnd: number = 15;
  Unit: string = "";
  fullData: any;
  f: any = {
    Id: 0,
    LocationId: this.ds.Settings.LocationId,
    CompanyId: this.ds.Settings.CompanyId,
    ToBranchId: 0,
    VoucherNo: "",
    RequisitionDate: "",
    Staus: "",
    ToLocation: "",
    ToLocationId: 0,
    ToCompanyId: 0,
    UserId: this.ds.Settings.UserId,
    Details: [],
    FromLocation:""
  };
  private el: ElementRef;
  @Input() onReturn: string;
  constructor(dialogService: DialogService, private ips: InTransactionsService, private ds: DataService) {
    super(dialogService);
    this.fullData = this.data;
  }

  ngOnInit() {
    this.fullData = this.data;
    if (!this.fullData) {
      this.close();
    } else {
      this.loading = true;
    }
  }
  confirm(item) {
    this.result = { item: item, result: true };
    this.close();
  }
  setClickedRow(e) {
    this.selectedRow = e;
    document.getElementById("focus").focus();
  }
  NextBut() {
    if (this.NexbutEnable()) {
      this.fullData = this.data;
      this.sliceEnd = Number(this.sliceEnd) + 15
      this.selectedRow = 0
    }
  }
  PreBut() {
    if (!this.PrebutEnable()) {
      this.fullData = this.data;
      this.sliceEnd = Number(this.sliceEnd) - 15
      this.selectedRow = 0
    }
  }
  NexbutEnable(): boolean {
    return this.fullData.length > this.sliceEnd
  }
  PrebutEnable(): boolean {
    return this.sliceEnd < 16
  }
  ItesmSearch(e, type) {
    if (e.keyCode == 13 && e.which == 13) {
      this.fullData = this.data;
      switch (type) {
        case "VoucherNo":
          this.f.VoucherNo = e.target.value;
          break;
        case "RequisitionDate":
          this.f.RequisitionDate = e.target.value;
          break;
        case "FromLocation":
          this.f.FromLocation = e.target.value;
          break;
      }
      this.selectedRow = 0;
      var Filterdata: any = {
        LocationId: this.ds.Settings.LocationId,
        RequestedList: {
          Start: 0,
          FiterText: "",
          Limit: this.ds.Settings.MaxLimit,
          ItemTypeId: this.ds.Settings.ItemTypeId,
          CAType: this.ds.Settings.CAType
        },
        FilterData: this.f
      }
      this.ips.getRequisitionSearch(Filterdata).subscribe(res => {
        if (res.Success) {
          this.fullData = res.data
        }
        else {
          this.fullData = []
        }
      });
    } else if (e.keyCode == 40 && e.which == 40) {
      document.getElementById("focus").focus();
      this.selectedRow = 0;
    }
  }
  scroll(event: KeyboardEvent) {
    //up 38 down 40
    event.preventDefault();
    if (event.keyCode === 40) {
      if (this.selectedRow > 13) {
        this.NextBut();
      } else {
        this.selectedRow++;
      }
    } else if (event.keyCode === 38) {
      if (this.selectedRow < 1) {
        this.PreBut();
      } else {
        this.selectedRow--;
      }
    } else if (event.keyCode === 13) {
      this.selecedItem();
    }
    else return;
  }
  selecedItem() {
    var abc = document.getElementsByClassName("selectedItesmsaerch786")[0].getElementsByClassName("bkd")[0].innerHTML;
    var bcd = this.fullData.find(x => x.VoucherNo == abc);
    this.confirm(bcd);
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/materialrequisition-search/materialrequisition-search.component.ts